export const mediaGalleryDefaults = {
  mediaItems: [
    {
      mediaType: 'photo',
      desktopImgSrc:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F1341ce0bbeaf4d7ab58533225cc892b6',
      mobileImgSrc:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F1341ce0bbeaf4d7ab58533225cc892b6',
    },
    {
      mediaType: 'photo',
      desktopImgSrc:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F954e26db85ad4a29ba740bcd3e2877bd',
      mobileImgSrc:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F954e26db85ad4a29ba740bcd3e2877bd',
    },
    {
      mediaType: 'video',
      brightcoveVideoId: '5632516551001',
      videoPlayerAspectRatio: '16 / 9',
      videoThumbnailImgSrc:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fdd78f2d33da34c38b1adbfb4139466be',
    },
  ],
}
